<template>
  <div
    class="checkout-payment-type-items"
    v-if="paymentMethodsEnabled.includes('pix')"
  >
    <div
      :class="{
        'eu-border-color_focus': checkout.accepted_payment_methods.includes(
          'pix'
        )
      }"
      class="
        eu-height_100
        emd-form-box
        _border_base
        _active
        checkout-payment-type-container
      "
    >
      <div class="emd-form-box__header">
        <label class="emd-checkbox" for="pix">
          <input
            class="emd-checkbox__input"
            name="pix"
            type="checkbox"
            id="pix"
            v-model="acceptPixCheckBox"
            :checked="acceptPixCheckBox"
            data-testid="checkbox"
            @click="updatePaymentMethod('pix')"
          />
          <div class="emd-checkbox__area"></div>
          <i
            class="emd-form-box__image uil uil-icon-2x uil-qrcode-scan"
            data-testid="icon"
            :class="{
              'emd-text _color_tertiary': checkout.accepted_payment_methods.includes(
                'pix'
              )
            }"
          ></i>
          <span class="emd-checkbox__text">
            {{ $t('checkout.pix.title') }}
          </span>
        </label>
      </div>
      <div class="emd-form-box__content">
        <div class="emd-form-group">
          <label class="emd-label">{{ $t('checkout.pix.due_date') }}</label>
          <div class="emd-input-group">
            <input
              class="emd-input"
              type="text"
              v-model="pixExpirationDate"
              v-mask="'##/##/####'"
              placeholder="dd/mm/aaaa"
              :disabled="!acceptPixCheckBox"
              :class="{ _state_error: pixFeedbackError }"
              data-testid="input"
            />
          </div>
          <p class="emd-input-feedback">
            {{
              $t('checkout.pix.expires_at', {
                date: buildCheckoutExpirationDate()
              })
            }}
          </p>
          <p class="emd-input-feedback _state_error" v-if="pixFeedbackError">
            {{ $t('Data deve ser válida') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setCurrentDate, fromatParseDate, isEmpty } from '@/utils/validations'

export default {
  name: 'PixCard',
  data () {
    return {
      acceptPixCheckBox: false,
      pixExpirationDate: ''
    }
  },
  props: {
    checkout: Object,
    checkoutExpirationDate: Number,
    paymentMethodsEnabled: Array,
    pixFeedbackError: Boolean,
    updatePaymentMethod: Function
  },
  methods: {
    validatePixExpirationDate () {
      const pixExpirationDate = fromatParseDate(this.checkout.pix.expires_at)
      const checkoutExpirationDate = fromatParseDate(
        this.buildCheckoutExpirationDate()
      )
      if (pixExpirationDate > checkoutExpirationDate) {
        this.$emit('setPixFeedbackError', false)
      } else {
        this.$emit('setPixFeedbackError', true)
      }
    },
    buildCheckoutExpirationDate () {
      return setCurrentDate(this.checkoutExpirationDate / 60 / 24)
    }
  },
  watch: {
    pixExpirationDate: {
      handler: function () {
        this.checkout.pix.expires_at = this.pixExpirationDate
        this.validatePixExpirationDate()
      }
    },
    checkoutExpirationDate: {
      handler: function () {
        if (this.acceptPixCheckBox) {
          this.validatePixExpirationDate()
        } else {
          this.$emit('setPixFeedbackError', false)
        }
      }
    },
    acceptPixCheckBox: {
      handler: function () {
        if (!this.acceptPixCheckBox) {
          this.$emit('setPixFeedbackError', false)
        } else {
          if (!isEmpty(this.pixExpirationDate)) {
            this.validatePixExpirationDate()
          }
        }
      }
    }
  },
  beforeMount () {
    if (this.checkout.accepted_payment_methods.includes('pix')) {
      this.acceptPixCheckBox = true
      this.pixExpirationDate = this.checkout.pix.expires_at
    }
  }
}
</script>

<style>
.checkout-payment-type-container {
  width: 17rem;
}

@media (max-width: 670px) {
  .checkout-payment-type-container {
    width: 20rem;
  }
}

.uil-qrcode-scan {
  font-size: 22px;
}
</style>
